import React, {useEffect, useState} from 'react';
import Shop from './shop/Shop';
import { Accordion } from 'react-accessible-accordion'
import {lang} from '../../common/baseData';

function RegionShops(props) {
  const [showAll, setShowAll] = useState(false)
  const INITIAL_SHOPS_COUNT = 3
  const hasMoreShops = props.shops.length > INITIAL_SHOPS_COUNT

  function getMessage(code) {
    return props.messages.hasOwnProperty(code)
        ? props.messages[code]
        : 'Lang message not defined';
  }

  const shops = props.shops.map((shop, i) => {
    const isHidden = !showAll && i >= INITIAL_SHOPS_COUNT
    return <Shop {...shop} className={isHidden ? 'hidden' : ''} getMessage={getMessage} key={i} lang={lang}/>;
  });

  return (
      <>
        {
          Array.isArray(props.shops) && props.shops.length ?
              <div className="content shops desktop:p-0 px-[20px]">
                <span className="text-[16px] leading-[24px] font-medium text-grey-90 desktop:text-[24px] desktop:leading-[36px]">
                  {props.title}
                </span>
                <div>
                  <Accordion allowZeroExpanded={true}>{shops}</Accordion>
                </div>
                {
                  hasMoreShops && !showAll && (
                  <div className="inline-block cursor-pointer mt-[10px] w-auto text-blue-primary text-[14px] leading-[21px] underline desktop:text-[16px] desktop:leading-[24px] hover:no-underline"
                       onClick={() => setShowAll(true)}>
                    {getMessage('CT_BNL_SM_SHOW_ALL_SHOPS')}
                  </div>
                )}
              </div> :
              <></>
        }
      </>
  );
}

export default RegionShops;
